export default "/images/pdf.svg";